import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowLeft20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M0.939331 10L7.96966 17.0303L9.03032 15.9697L3.81065 10.75L19 10.75V9.25001L3.81066 9.25L9.03032 4.03034L7.96966 2.96968L0.939331 10Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowLeft20.displayName = 'ArrowLeft20';
export default ArrowLeft20;
